export const SENTIMENT_SET = {
  "positive": "긍정",
  "negative": "부정",
  "mix": "혼합",
  "neutral": "중립"
}